import React from 'react'
import Paragraph from "../Paragraph/Paragraph";
import First from "../First/First";
import Second from "../Second/Second";
import Third from "../Third/Third";
import Fourth from "../Fourth/Fourth";
import Fifth from "../Fifth/Fifth";
import Sixth from "../Sixth/Sixth";
import Youtube from "../Youtube/Youtube";

const Home = () => {
  return (
    <div>
        <Paragraph/>
        <First/>
        <Second/>
        <Third/>
        <Fourth/>
        <Fifth/>
        <Sixth/>
        <Youtube/>
    </div>
  )
}

export default Home